import React from 'react';
import { QuestRoute } from '../../../api/QuestRoutes';
import { formatCurrency, generateId } from '../../../utility/functions';
import Table from '../../../table/Table';
import LinkTo from '../../../forms/LinkTo';
import Col from '../../../layout/Col';


const Activity = ({ ...props }) => {

    const tableConfig = {
        endpoint: QuestRoute.reports.express.activity,
        isReport: true,
        headers: [
            {
                label: 'Account',
                propKey: 'name',
            }, {
                label: 'Account ID',
                propKey: 'loyaltyAccountId',
            }, {
                label: 'Club',
                propKey: 'clubName',
                options: true
            }, {
                label: 'Club Price',
                propKey: 'packagePrice',
                options: true
            }, {
                label: 'Use Count',
                propKey: 'useCount',
                sortBy: true,
                ascending: false
            }, {
                label: 'Average Revenue',
                propKey: 'averageRevenue',
                type: 'number'
            },
        ],
        sticker: [
            {
                label: 'Total Club Uses',
                color: '#21D59B',
                callback: (data) => data.reduce((a, b) => b.useCount + a, 0)
            }, {
                label: 'Average Revenue Per Wash',
                color: '#21D59B',
                callback: (data) => {
                    return formatCurrency(data.reduce((a, b) => b.averageRevenue + a, 0) / (data.reduce((a, b) => b.useCount + a, 0) || data.length) || 0)
                }
            }, {
                label: 'Average Revenue Per Club',
                color: '#21D59B',
                callback: (data) => formatCurrency(data.reduce((a, b) => (b.averageRevenue) + a, 0) / data.length || 0)
            },
        ],
        renderFormat: (e) => (
            <tr key={generateId()}>
                <td>
                    <LinkTo
                        target='_blank'
                        loyaltyAccountId={e.loyaltyAccountId}
                    >
                        {e.name}
                    </LinkTo>
                </td>
                <td>{e.loyaltyAccountId}</td>
                <td>{e.clubName}</td>
                <td>{formatCurrency(e.packagePrice)}</td>
                <td>{e.useCount}</td>
                <td>{formatCurrency(e.averageRevenue)}</td>
            </tr>
        )
    }

    return (
        <Col style={{ width: '100%' }}>
            {/* <Bar /> */}
            <Table config={tableConfig} />
        </Col>
    );
}

export default Activity;